import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const Container = styled.div``;
export const Description = styled.div`
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.69;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const Title = styled.div`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 36px;
	line-height: 42px;
	text-align: center;

	color: ${COLOR_TEXT_PRIMARY_B2C};
`;
